export const AuthEventTypes = {
  REFRESH_TOKEN_SUCCESS: 'REFRESH_TOKEN_SUCCESS',
  REFRESH_TOKEN_FAIL: 'REFRESH_TOKEN_FAIL',
  LOGOUT_SIGNAL: 'LOGOUT_SIGNAL',
  UNAUTHORISED_SIGNAL: 'UNAUTHORISED_SIGNAL',
} as const;

export const ChatEventTypes = {
  INPUT_FOCUS_CHANGE: 'INPUT_FOCUS_CHANGE',
  SCROLL_TO_BOTTOM: 'SCROLL_TO_BOTTOM',
  TOGGLE_SHOW_SCROLL_TO_BOTTOM: 'TOGGLE_SHOW_SCROLL_TO_BOTTOM',
} as const;

export type EventName =
  | keyof typeof AuthEventTypes
  | keyof typeof ChatEventTypes;

export default {
  listeners: {} as Record<EventName, Array<(...args: any[]) => void>>,
  addEventListener<T = any>(
    event: EventName,
    callback: (data: { event: EventName; payload: T }) => void,
  ) {
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(callback);

    return () => {
      this.removeEventListener(event, callback);
    };
  },
  removeEventListener<T = any>(
    event: EventName,
    callback: (data: { event: EventName; payload: T }) => void,
  ) {
    this.listeners[event] = this.listeners[event].filter(
      (cb) => cb !== callback,
    );
  },
  broadcastEvent<T = any>(event: EventName, payload?: T) {
    if (this.listeners[event])
      this.listeners[event].forEach((cb) => cb({ payload, event }));
  },
  addMultiEventListener<T = any>(
    events: EventName[],
    callback: (data: { event: EventName; payload: T }) => void,
  ) {
    events.forEach((event) => {
      if (!this.listeners[event]) this.listeners[event] = [];
      this.listeners[event].push(callback);
    });
  },
  removeMultiEventListener<T = any>(
    events: EventName[],
    callback: (data: { event: EventName; payload: T }) => void,
  ) {
    events.forEach((event) => {
      this.listeners[event] = this.listeners[event].filter(
        (cb) => cb !== callback,
      );
    });
  },
};
